import React from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import Logo from "@/components/Logo";
import { Button } from "@/components/ui/button";
import { LogOut, LayoutDashboard, Truck } from "lucide-react";

export default function Navbar() {
  const { user, logout, setSession } = useAuth();
  const navigate = useNavigate();
  const home = user?.role === "admin" ? "/admin" : user?.role === "driver" ? "/driver" : "/dashboard";
  const impersonating = user && user.role !== "admin" && !!localStorage.getItem("kc_admin_backup");

  const returnToAdmin = async () => {
    await api.post("/auth/impersonate/end").catch(() => {});
    const backup = localStorage.getItem("kc_admin_backup");
    localStorage.removeItem("kc_admin_backup");
    await setSession(backup);
    navigate("/admin");
  };

  return (
    <header className="sticky top-0 z-40 border-b border-border/60 bg-white/80 backdrop-blur-xl">
      {impersonating && (
        <div className="flex items-center justify-center gap-3 bg-kilted-gold px-4 py-1.5 text-xs font-semibold text-kilted-green" data-testid="impersonation-banner">
          Troubleshooting as {user.name}
          <button onClick={returnToAdmin} data-testid="return-to-admin-button" className="rounded-full border border-kilted-green px-2.5 py-0.5 transition-colors hover:bg-kilted-green hover:text-white">
            Return to admin
          </button>
        </div>
      )}
      <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-3 sm:px-6">
        <button onClick={() => navigate(home)} data-testid="nav-home-button" className="transition-transform hover:-translate-y-px">
          <Logo />
        </button>
        <div className="flex items-center gap-3">
          <div className="hidden text-right sm:block">
            <div className="text-sm font-semibold text-foreground" data-testid="nav-user-name">{user?.name}</div>
            <div className="text-xs capitalize text-muted-foreground">{user?.role}</div>
          </div>
          {user?.role === "admin" && (
            <Button variant="ghost" size="sm" onClick={() => navigate("/driver")} data-testid="nav-driver-view-button" className="gap-1.5">
              <Truck className="h-4 w-4" /> <span className="hidden sm:inline">Driver view</span>
            </Button>
          )}
          <Button variant="ghost" size="sm" onClick={() => navigate(home)} data-testid="nav-dashboard-button" className="gap-1.5">
            <LayoutDashboard className="h-4 w-4" /> <span className="hidden sm:inline">Dashboard</span>
          </Button>
          <Button variant="outline" size="sm" onClick={() => { logout(); navigate("/login"); }} data-testid="nav-logout-button" className="gap-1.5">
            <LogOut className="h-4 w-4" /> <span className="hidden sm:inline">Log out</span>
          </Button>
        </div>
      </div>
    </header>
  );
}
